import { render, staticRenderFns } from "./TicketStaffReport.vue?vue&type=template&id=0bea1ca0&scoped=true"
import script from "./TicketStaffReport.vue?vue&type=script&lang=js"
export * from "./TicketStaffReport.vue?vue&type=script&lang=js"
import style0 from "./TicketStaffReport.vue?vue&type=style&index=0&id=0bea1ca0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bea1ca0",
  null
  
)

export default component.exports